import React from 'react';
import {RxDatagrid, FilterField} from 'reactis-datagrid';
import classnames from 'classnames';

export default class ImageGrid extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			selected: []
		}
	}

	handleClick(e, row) {
		e.preventDefault();
		this.props.editClick(row);
		if (this.props.popup) {
			this.state.selected.push(row.id);
			this.forceUpdate();
		}
	}

	render() {

		const items = this.props.rows.map((row) => {
			row = row.toJS();
			const selected = this.state.selected.indexOf(row.id) != -1;
			return (
				<div key={row.id} className="col-md-2 col-sm-4 col-xs-6">
					<div className="thumbnail">
						<div className="thumb"
							 style={{textAlign:'center', cursor:'pointer'}}
							 onClick={(e) => this.handleClick(e, row)}>
							{selected && <span className="selected icon-check"></span>}
							{row.image &&
							<img style={{width:row.image.width, height: row.image.height, border: '1px solid #BBB'}} src={row.image.url} alt=""/>
							}
						</div>

						<div className="caption" style={{padding: '4px 7px 0px 7px', borderTop: '1px solid #d6d6d6', marginTop: 4}}>
							<h6 className="no-margin">
								<span style={{display:'inline-block', fontSize: 13, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '75%'}}>
								{row.title}
								</span>
								{!this.props.popup &&
								<a onClick={(e) => this.handleClick(e, row)} href="#" className="text-muted"><i
									className="fa fa-pencil pull-right"></i></a>
								}
							</h6>
						</div>
					</div>
				</div>
			)
		});

		return (
			<div className="row">
				{items}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/ImageGrid.js